import { FC } from 'react';
import { BoxV2 as Box, SxProps } from 'portal-commons';

export const Divider: FC<{ sx?: SxProps }> = ({ sx }) => {
  return (
    <Box
      sx={{
        minHeight: '1px',
        height: '1px',
        backgroundColor: '#EAF0F2',
        ...sx,
      }}
    />
  );
};

export default Divider;
